import Styles from './style.module.scss';
import {
  Radio,
  Input,
  Button,
  Checkbox,
  Form,
  Row,
  Col,
  message,
  Select,
  Space,
} from 'antd';
import { useEffect, useState } from 'react';
import router from 'next/router';
import request from '../../utils/request/next-request';
import SuggestHeader from '../../components/suggestion/suggestHeader';
import Agreement from '../../components/commonComponents/agreement';
import Success from '../../components/commonComponents/success';
import { getConsultTaskOptions } from '../../services/common';
import { useUserAgentInfo } from '../../context/user-agent';
import MobileAppointment from '../../components/fromComponents/appointment/MobileAppointment';
import CaptchaForm from '../../components/fromComponents/CaptchaForm';
import { getQueryVariable } from '../../utils/common';
import useWebLogger from '@/hooks/useWebLogger';
import { formEvent } from '@/utils/const/weblogger/event';
import { defaultConsultOptions } from '@/utils/config';

const INPUT_WIDTH = 400;

export const getServerSideProps = async (context) => {
  const { url } = context.req;
  const pair = url.split('?')[1]?.split('=') || ['source', '1'];
  const sourceCode = pair[0] === 'source' ? pair[1] : '1';
  try {
    const res = await getConsultTaskOptions();
    return {
      props: {
        sectorMap: res[1].fieldItemModels,
        bizMap: res[2].fieldItemModels,
        sourceCode,
      },
    };
  } catch (err) {
    return {
      props: {
        sectorMap: defaultConsultOptions[1].fieldItemModels,
        bizMap: defaultConsultOptions[2].fieldItemModels,
        sourceCode,
      },
    };
  }
};

const AppointmentPC = ({ suggestions, sectorMap, onCreate, bizMap }) => {
  const [agree, setAgree] = useState<boolean>(false);
  const { clickEventRef } = useWebLogger();
  const [form] = Form.useForm();
  return (
    <div className={Styles.container}>
      <div className={Styles.wrapper}>
        <SuggestHeader {...suggestions} />
        <Form
          name="basic"
          initialValues={{ remember: true, AreaCode: '+86' }}
          autoComplete="off"
          layout="vertical"
          onFinish={(values) => onCreate(values)}
          form={form}
          validateTrigger="onBlur"
        >
          <Form.Item
            label="姓名"
            name="name"
            rules={[{ required: true, message: '请输入联系人姓名' }]}
          >
            <Input
              placeholder="请输入联系人姓名"
              maxLength={20}
              style={{ width: INPUT_WIDTH }}
            />
          </Form.Item>
          <CaptchaForm
            form={form}
            afterSendCaptcha={() => {
              clickEventRef?.current({
                action: formEvent.BookValidate,
              });
            }}
          />
          <Form.Item
            label="公司名称"
            name="company"
            rules={[{ required: true, message: '请输入公司全称' }]}
          >
            <Input
              placeholder="请输入公司全称"
              maxLength={50}
              style={{ width: INPUT_WIDTH }}
            />
          </Form.Item>
          <Form.Item
            label="所在行业"
            name="industry"
            rules={[{ required: true, message: '请选择所在行业' }]}
          >
            <Radio.Group>
              {sectorMap.map((s) => (
                <Radio value={s.itemValue} key={s.itemValue}>
                  {s.itemName}
                </Radio>
              ))}
            </Radio.Group>
          </Form.Item>
          <Form.Item
            label="业务类型"
            name="businessType"
            rules={[{ required: true, message: '请选择业务类型' }]}
          >
            <Checkbox.Group>
              <Row gutter={[16, 8]}>
                {bizMap.map((b) => (
                  <Col key={b.itemValue}>
                    <Checkbox value={b.itemValue}>{b.itemName}</Checkbox>
                  </Col>
                ))}
              </Row>
            </Checkbox.Group>
          </Form.Item>
          <Form.Item
            name="agreement"
            rules={[
              {
                validator: () => {
                  return agree
                    ? Promise.resolve()
                    : Promise.reject(new Error('请同意服务条款'));
                },
              },
            ]}
          >
            <Agreement onChange={(isChecked) => setAgree(isChecked)} />
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              className={Styles['submit-btn']}
            >
              提交
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default function Appointment({ sectorMap, bizMap, sourceCode }) {
  useEffect(() => {
    router.replace('/activity/publish');
  }, []);

  const { isMobile } = useUserAgentInfo();
  const [success, setSuccess] = useState<boolean>(false);
  const { clickEventRef } = useWebLogger();
  const suggestions = {
    titleText: 'StreamLake品牌发布会',
    titleDesc: '感谢您对本次发布会的关注，请填写以下信息进行活动预约',
  };

  const handleSubmit = async (values) => {
    delete values['agreement'];
    values['AreaCode'] ??= '+86';

    clickEventRef.current({
      action: formEvent.BookSubmit,
      params: { source: '1' },
    });

    const res = await request({
      url: `${process.env.NEXT_PUBLIC_API_BASE_URL}/appoint`,
      method: 'post',
      data: {
        ...values,
        sourceCode,
      },
    });
    if (res && (res.code === 0 || res.code === '0')) {
      setSuccess(true);
      return true;
    } else {
      message.error(res.msg || '请重试');
      return false;
    }
  };

  const params = {
    suggestions,
    sectorMap,
    bizMap,
    onCreate: handleSubmit,
  };

  if (success) {
    return <Success text={'感谢您的支持，我们将尽快与您联系'} />;
  }
  return (
    <>
      {isMobile ? (
        <MobileAppointment {...params} />
      ) : (
        <AppointmentPC {...params} />
      )}
    </>
  );
}
